import { api } from '../../../api/api';
import { InvoiceResponseType } from './types';

const INVOICES_TAG = 'invoices';

export const invoicesApi = api.enhanceEndpoints({ addTagTypes: [INVOICES_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    getInvoices: build.query<InvoiceResponseType[], { customerId: string }>({
      query: ({ customerId }) => ({
        method: 'GET',
        url: 'invoices/fetch-invoices/' + customerId
      })
    })
  })
});

export const { useGetInvoicesQuery } = invoicesApi;
